var React = require('react');

function Economy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.14,17.17v1.49c0,1.23,3,2.24,6.7,2.24s6.7-1,6.7-2.24V17.17c-1.44,1-4.08,1.49-6.7,1.49S4.58,18.19,3.14,17.17Z","key":0}),React.createElement("ellipse",{"cx":"14.3","cy":"5.27","rx":"6.7","ry":"2.23","key":1}),React.createElement("path",{"d":"M3.14,13.52v1.79c0,1.24,3,2.24,6.7,2.24s6.7-1,6.7-2.24V13.52c-1.44,1.18-4.08,1.79-6.7,1.79S4.58,14.7,3.14,13.52Z","key":2}),React.createElement("path",{"d":"M17.65,13.9c2-.39,3.35-1.11,3.35-1.93V10.48a8.6,8.6,0,0,1-3.35,1.2Z","key":3}),React.createElement("ellipse",{"cx":"9.84","cy":"11.41","rx":"6.7","ry":"2.79","key":4}),React.createElement("path",{"d":"M17.49,10.58c2.09-.37,3.51-1.11,3.51-2V7.13a11.3,11.3,0,0,1-5.6,1.46A4,4,0,0,1,17.49,10.58Z","key":5})]);
}

Economy.defaultProps = {"fill":"currentColor","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Economy;

Economy.default = Economy;
